var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29_115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 78,
    height: 78
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 76.9999V0.999908H1V76.9999H77Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8674 55.6059C26.5351 55.6059 17.9763 47.1994 17.9763 36.8671C17.9763 26.5349 26.5351 18.1284 36.8674 18.1284C47.1997 18.1284 55.6061 26.5349 55.6061 36.8671C55.6061 47.1994 47.1997 55.6059 36.8674 55.6059Z",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8672 27.269C42.1605 27.269 46.4653 31.5738 46.4653 36.8671",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5159 53.053C61.5028 50.2795 62.9935 47.1261 63.8588 43.7226H71.1448V30.0117H63.8588C63.2002 27.4171 62.1685 24.9318 60.7962 22.6335L65.9526 17.4771L56.2574 7.78197L51.1011 12.9383C48.8027 11.566 46.3175 10.5344 43.7229 9.87578V2.2851H30.012V9.87578C27.3828 10.5441 24.754 11.5813 22.4813 12.9383L17.3249 7.78197L7.62977 17.4771L12.7861 22.6335C11.4138 24.9318 10.3822 27.4171 9.72358 30.0117H2.2854V43.7226H9.72358C10.3822 46.3172 11.4138 48.8026 12.7861 51.1009L7.47743 56.2573L17.3249 65.9524L22.4813 60.7961C24.754 62.1531 27.3828 63.1903 30.012 63.8586V71.1445H43.7229V63.8586C47.1263 62.9933 50.2796 61.5025 53.0532 59.5158",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9456 46.4829L74.8007 68.338L68.3381 74.8007L46.4829 52.9456",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4827 67.9452L67.9454 61.4825",
    stroke: "#2FC77E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.a9a5d222ab7c514c2bd7e447e96451c2.svg";
export { ForwardRef as ReactComponent };